<div class="form-panel__body" [formGroup]="form">

  <!-- Single field, nothing else to configure one static card, no
       collapse affordance needed (unlike the other playground pages, which
       split into multiple sections because they actually have multiple
       distinct groups of settings). -->
  <div class="query-section">
    <div class="query-section__header" style="cursor:default;">
      <div class="query-section__header-main">
        <app-section-icon class="query-section__icon" name="domain"></app-section-icon>
        <div class="query-section__header-text">
          <span class="query-section__title">Domain to check</span>
          <span class="query-section__desc">Which domain</span>
        </div>
      </div>
    </div>
    <div class="query-section__body" style="display:flex;">


      <div class="form-field">
        <label class="form-field__label">Domain name<span class="form-field__required">*</span></label>
        <input type="text" class="field-input field-input--text" formControlName="domain" placeholder="https://www.cikisi.com/" />
      </div>

    </div>
  </div>

  <div class="explainer-box">
    <p class="explainer-box__title">What this endpoint returns</p>
    <p class="explainer-box__body">A concise analysis of the legal framework for using data from the given domain name including terms of service, robots.txt restrictions, license terms, and applicable jurisdictions. See our new Data Usage Compliance Check service.</p>
  </div>

</div>
